import React from 'react'
import {observer} from 'mobx-react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {LiveGameContainerBox} from './boxes/live-game-container/live-game-container.box';
import {LiveCasinoArenaGridItem} from '../../arena-host/new-live-casino-arena/live-casino-arena-grid/live-casino-arena-grid-item.component';
import {GameInfo} from '../../../services/games/game-info';

export interface SingleGameLiveTemplateComponentProps {
    tableConfig: GameInfo;
}

export const SingleGameLiveTemplateComponent = observer(
    class SingleGameLiveTemplateComponent extends OrbitComponent<SingleGameLiveTemplateComponentProps> {

        render() {
            return (
                <LiveGameContainerBox>
                    <LiveCasinoArenaGridItem
                        key={this.props.tableConfig.gameType}
                        tableId={this.props.tableConfig.gameType}
                        gameInfo={this.props.tableConfig}
                        gameIndex={0}
                        listTitle={""}
                        liveTable={this.services.liveTableFeeds.getTableInfo(this.props.tableConfig.gameType)}
                        fluidWidth
                        seoCategory={null}
                        captureGameElementRef={null}
                    />
                </LiveGameContainerBox>
            );
        }
    }
);


